import { IResponse } from "../contracts/IResponse";
import { HttpMethodEnum } from "../enums/enums";
import { Claim } from "../models/Claim";
import { DiscountVoucherModel } from "../models/DiscountVoucherModel";
import { Order } from "../models/Order";
import { SignInModel } from "../models/SignInModel";
import { BaseService } from "./BaseService";

export class DiscountVoucherService extends BaseService {
    constructor() {
        super("discountvoucher")
    }

    GetByCode(voucherCode: string, productID:number): Promise<IResponse<DiscountVoucherModel>> {
        return fetch(`${this.EndPoint}/getbycode/${voucherCode}/${productID}`, { method: HttpMethodEnum.GET, headers:{ "Content-Type": "application/json" }}).then(response => response.json())
    }
}